import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";
import { createAction, EmptyAction, PayloadAction } from "typesafe-actions";

export const setChatFoldersAction: (
  chatFolders: ChatFolderData[]
) => PayloadAction<"chatFolders/setChatFoldersAction", ChatFolderData[]> = createAction(
  "chatFolders/setChatFoldersAction"
)<ChatFolderData[]>();

export const getChatFoldersAction: () => EmptyAction<"chatFolders/getChatFoldersAction"> = createAction(
  "chatFolders/getChatFoldersAction"
)();

export const setCurrentFolderAction: (
  chatFolder: ChatFolderData | null
) => PayloadAction<"chatFolders/setCurrentFolderAction", ChatFolderData | null> = createAction(
  "chatFolders/setCurrentFolderAction"
)<ChatFolderData | null>();

export const createChatFoldersAction: (
  chatFolders: ChatFolderData
) => PayloadAction<"chatFolders/createChatFoldersAction", ChatFolderData> = createAction(
  "chatFolders/createChatFoldersAction"
)<ChatFolderData>();

export const setSelectChatFoldersAction: (
  chatFolders: ChatFolderData[]
) => PayloadAction<"chatFolders/setSelectChatFoldersAction", ChatFolderData[]> = createAction(
  "chatFolders/setSelectChatFoldersAction"
)<ChatFolderData[]>();

export const selectChatChangeFoldersAction: (
  chatFolders: ChatFolderData[]
) => PayloadAction<"chatFolders/selectChatChangeFoldersAction", ChatFolderData[]> = createAction(
  "chatFolders/selectChatChangeFoldersAction"
)<ChatFolderData[]>();

export const selectChangeFolderAction: (
  chatFolder: ChatFolderData
) => PayloadAction<"chatFolders/selectChangeFolderAction", ChatFolderData> = createAction(
  "chatFolders/selectChangeFolderAction"
)<ChatFolderData>();

export const selectDeleteFolderAction: (
  chatFolder: ChatFolderData
) => PayloadAction<"chatFolders/selectDeleteFolderAction", ChatFolderData> = createAction(
  "chatFolders/selectDeleteFolderAction"
)<ChatFolderData>();
